import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { ImageModal } from "../../components";
import { ProductType } from "../../types/General";
import { getFromStorage } from "../../constants/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";

type props = {
  productData?: any;
};

const ProductInfoDetails = ({ productData }: props) => {
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const t = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const handleClose = () => setOpen(false);

  const handleOpenModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  return (
    <Card className="cards">
      <CardContent sx={{ p: 1 }}>
        <Grid container spacing={2} className="view_box">
          <Grid
            item
            xs={12}
            className="view_box_list"
            style={{ display: "flex", paddingBottom: 10 }}
          >
            {productData?.product_image?.map((item: any) => (
              <figure className="profile_img">
                <img
                  src={item?.media_url || `/static/images/default.png`}
                  alt=""
                />
                <div className="overlay">
                  <img
                    onClick={() =>
                      handleOpenModal(
                        item?.media_url || "/static/images/default.png"
                      )
                    }
                    src="/static/images/visibility.png"
                    alt="view"
                  />
                </div>
              </figure>
            ))}
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                component="h5"
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
              >
                {t.main.productNameAr}
              </Typography>

              <Typography component="p">
                {productData?.product_name_ar || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                component="h5"
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
              >
                {t.main.productNameEn}{" "}
              </Typography>
              <Typography component="p">
                {productData?.product_name_en || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                component="h5"
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
              >
                {t.main.productNameRu}{" "}
              </Typography>
              <Typography component="p">
                {productData?.product_name_rs || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                component="h5"
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
              >
                {t.main.price}
              </Typography>
              <Typography component="p">
                {currency === "USD" ? "USD" : "AED"}{" "}
                {productData?.price_per_unit || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.minPerchaseQty}
              </Typography>
              <Typography component="p">
                {productData?.min_quantity || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.productQuantity}
              </Typography>
              <Typography component="p">
                {productData?.total_quantity || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                component="h5"
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
              >
                {t.main.category}
              </Typography>
              <Typography component="p">
                {productData?.sub_category?.sub_category_name_en || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                component="h5"
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
              >
                {t.main.subCategory}
              </Typography>
              <Typography component="p">
                {productData?.sub_category?.category?.category_name_en || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.gradeAr}
              </Typography>
              <Typography component="p">
                {productData?.grade_ar || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.gradeEn}
              </Typography>
              <Typography component="p">
                {productData?.grade_en || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.gradeRu}
              </Typography>
              <Typography component="p">
                {productData?.grade_rs || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.shelfAr}
              </Typography>
              <Typography component="p">
                {productData?.shell_life_ar || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.shelfEn}
              </Typography>
              <Typography component="p">
                {productData?.shell_life_en || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.shelfRu}
              </Typography>
              <Typography component="p">
                {productData?.shell_life_rs || "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.descAr}
              </Typography>
              <Typography component="p">
                {productData?.product_desc_ar || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.descEng}
              </Typography>
              <Typography component="p">
                {productData?.product_desc_en || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Box>
              <Typography
                sx={{ color: "grey.600", fontSize: "0.875rem" }}
                component="h5"
              >
                {t.main.descRu}
              </Typography>
              <Typography component="p">
                {productData?.product_desc_rs || "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <ImageModal open={open} handleClose={handleClose} image={selectedImage} />
    </Card>
  );
};

export default ProductInfoDetails;
